import { useTranslation } from "react-i18next";

import { useTyrePositionName } from "hooks";
import { QuestionResultStatusSelector } from "modules/AppointmentDetails/components/Checks/components/Check/components/QuestionResults/components";
import { ImageLetters } from "modules/AppointmentDetails/components/Interventions/components/PinOverview/components";
import "modules/AppointmentDetails/components/Interventions/components/PinOverview/components/ChecklistSection/ChecklistSection.scss";
import { isInStorageTyre, isOnCarTyre } from "modules/AppointmentDetails/utils";

import type { QuestionResultWithLetteredImages } from "modules/AppointmentDetails/components/Interventions/components/PinOverview/components/ChecklistSection/hooks";

type ChecklistSectionProps = {
  question: QuestionResultWithLetteredImages;
};

const ChecklistSection = ({ question }: ChecklistSectionProps) => {
  const { t } = useTranslation();

  const tyrePositionName = useTyrePositionName(question.tyre_position);

  const { mechanic_notes, tyre, tyre_position } = question;

  return (
    <div className="checklist-item" key={question.id}>
      <div>
        <div className="checklist-item-text-image-letter">
          <ImageLetters letteredImages={question.letteredImages} />
          <div className="checklist-item-title">
            {tyre_position && (
              <>
                {isOnCarTyre(tyre_position) && t("v8_on_car", "On car") + " "}
                {isInStorageTyre(tyre_position) && t("v8_in_storage", "In storage") + " "}
                {tyrePositionName}
              </>
            )}
          </div>
        </div>
        <p className="checklist-item-description">
          {tyre?.description && <div>{tyre.description}</div>}
          {mechanic_notes && <div>{mechanic_notes.trim()}</div>}
          {question.tyre_replacements?.map(tr => (
            <div key={tr.tyre_replacement_id}>
              {t("v8_replace_with", "Replace with")}: {tr.tyre?.description}
            </div>
          ))}
        </p>
      </div>
      <QuestionResultStatusSelector questionResult={question} disabled={true} />
    </div>
  );
};

export default ChecklistSection;
